/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const Execute = lazyLoad(
  () => import('./index'),
  module => {
    return module.Execute;
  },
);
